import { createWebHistory } from "vue-router"
export default createWebHistory( import.meta.env.BASE_URL )
